export default {"src":"/_next/static/media/ico_copy.2098dd71.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};